/**
 * Storlyn 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = 'linear-gradient(90deg, #FF81B0 0%, #EE3BA4 100%)'

export const theme = {
  btnBg: brandTheme.primaryColor,
  btnText: brandTheme.textInverse,
  coinsColor: brandTheme.primaryColor,
  coinsGradient: primaryGradient,
  actionGradient: brandTheme.primaryGradient,
  checkinBtnGradient: primaryGradient,
} as const

export const resources = {
  homeBg: '/images/storlyn/home-bg.webp',
  welfareGold: '/images/storlyn/welfare-gold.png',
  welfareBox: '/images/storlyn/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
